import React from 'react';
import { inject, observer } from 'mobx-react';

import CaliberLogo from '../../assets/caliber-logo-white.svg';

@inject('headerState')
@observer
class FeaturedSponsor extends React.PureComponent {
  render() {
    const { memberSignedIn } = this.props.headerState;

    if (memberSignedIn === true) {
      return null;
    }

    return (
      <div className="featured-sponsor mvc-mobile-hide">
        <p className="flex-centered mvc-white-text secondary">
          Featured Sponsor
        </p>
        <a
          className="sponsor-logo"
          href="https://caliberhomeloans.com/"
          target="_blank"
          rel="noopener"
        >
          <img src={CaliberLogo} alt="Caliber Home Loans Logo" />
        </a>
      </div>
    );
  }
}

export default FeaturedSponsor;
